import { toMessageBundle } from './MessageBundle';
import { loadBundle, useTextLocalizer } from './useTextLocalizer';
const bundles = {};
export const getBundle = bundleName => bundles[bundleName];
export const addBundle = bundle => {
  bundles[bundle.name] = toMessageBundle(bundle);
};

/**
 * Creates a custom hook for getting a Localizer for the specified bundle. Components should
 * statically import their message bundle in their component and provide the result as the
 * bundle parameter.
 * @param bundle
 */
export const createUseTextLocalizer = bundle => {
  // Add it so that NovaWebpackBackend can know about it.
  addBundle(toMessageBundle(bundle));
  // Load it so that any other backends can start to prefetch if needed.
  loadBundle(bundle.name);
  return () => useTextLocalizer(bundle.name);
};

/**
 * Not for public consumption
 * @returns
 */
export const _bundleNames = () => Object.keys(bundles);
//# sourceMappingURL=createUseTextLocalizer.js.map